export enum EItemType {
  MESSAGE = "message",
  OPTIONS = "options",
  COLLECT = "collect",
  FIELD = "field",
  COMPARISON = "comparison",
  RESULT = "result",
}

export enum EItemComparisonType {
  VALUES = "values",
  NUMBER_INTERVAL = "number_interval",
}

export enum EItemFormatType {
  CURRENCY = "currency",
  CNPJ = "cnpj",
  EMAIL = "email",
  CELLPHONE = "cellphone",
  CPF = "cpf",
}

export interface IItemField {
  name: string;
  label: string;
  placeholder: string;
  type: string;
  required: boolean;
  format?: EItemFormatType;
  currency_min_value?: number | null;
  currency_max_value?: number | null;
}

export interface IItemOption {
  text: string;
  description?: string;
  next?: string;
}

export interface ICondition {
  field: string;
  type: EItemComparisonType,
  values?: (string | number)[];
  min_value?: number;
  max_value?: number;
}

export interface IItemComparison {
  id: string;
  title: string;
  conditions: ICondition[];
  next: string;
  order?: number;
  line_of_credit_id?: string;
}

export type Response = {
  [key: string]: string;
}

export type CollectResponse = {
  name: string;
  value: string | number;
  format?: EItemFormatType;
  label: string;
}

export interface IItem {
  id: string;
  type: EItemType;
  message_text: string | null;
  input_instructions?: string | null;
  fields?: IItemField[];
  options?: IItemOption[];
  comparisons?: IItemComparison[];
  itens?: IItem[];
  values_from?: string[];
  next?: string | null;
  default?: string;
  response?: string | number | Response | CollectResponse[] | IItemOption[];
  placeholder?: string;
  format?: EItemFormatType;
  line_of_credit?: string;
  is_initial_item: boolean;
  table_display_name?: string;
  link_text?: string;
  link?: string;
  allow_multiple_options?: boolean;
  currency_min_value?: number | null;
  currency_max_value?: number | null;
}

export interface IStoredChat {
  id: string;
  history: IItem[];
  startedAt: string;
}
